<template>
  <v-data-table
    hide-actions
    v-model="selected"
    :headers="headers"
    :items="items"
    item-key="id"
    select-all
  >
    <template v-slot:headers="props">
      <tr>
        <th>
          <v-checkbox
            :input-value="props.all"
            :indeterminate="props.indeterminate"
            primary
            hide-details
            :disabled="permits['UPDATE_PERMITS'] && !disabled ? false : true"
            @click.stop="toggleAll"
            color="primary"
          ></v-checkbox>
        </th>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="[
            'column sortable',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '',
          ]"
          @click="changeSort(header.value)"
        >
          <v-icon small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <td>
        <v-checkbox
          ripple
          color="primary"
          @change="sChck($event, props.item)"
          v-model="props.selected"
          :disabled="permits['UPDATE_PERMITS'] && !disabled ? false : true"
          primary
          hide-details
        ></v-checkbox>
      </td>
      <td>{{ props.item.nombre }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ['headers', 'items', 'approved', 'permits', 'disabled'],
  mounted() {
    this.selected = this.approved
  },
  watch: {
    approved() {
      this.selected = this.approved
    },
  },
  data: () => ({
    pagination: {
      sortBy: 'name',
    },
    selected: [],
  }),
  methods: {
    toggleAll() {
      if (this.selected.length) {
        this.$emit('uChckAll', this.selected)
        this.selected = []
      } else {
        this.selected = this.items.slice()
        this.$emit('chckAll', this.selected)
      }
    },
    sChck(value, item) {
      // HANDLE NESTED REPORTS
      if (item.name === 'WATCH_REPORTS' && value === true) {
        this.items
          .filter((e) => e.name !== 'UPDATEATTENDANCE_REPORTS')
          .forEach((el) => {
            this.$emit('chck', el)
          })

        this.selected = []
        return
      }

      if (item.name === 'WATCH_REPORTS' && value === false) {
        this.items
          .filter((e) => e.name !== 'UPDATEATTENDANCE_REPORTS')
          .forEach((el) => {
            this.$emit('uChck', el)
          })

        this.selected = []
        return
      }

      // HANDLE NESTED REPORTS
      if (
        item.name.split('_')[1] === 'REPORTS' &&
        item.name !== 'UPDATEATTENDANCE_REPORTS' &&
        item.name !== 'WATCH_REPORTS' &&
        value === true
      ) {
        const tempItem = this.items.filter((e) => e.name === 'WATCH_REPORTS')

        this.$emit('chck', item)

        if (
          this.selected.find((e) => e.name === 'WATCH_REPORTS') === undefined
        ) {
          this.$emit('chck', tempItem[0])
        }
        this.selected = []

        return
      }

      if (
        item.name.split('_')[1] === 'REPORTS' &&
        item.name !== 'UPDATEATTENDANCE_REPORTS' &&
        item.name !== 'WATCH_REPORTS' &&
        value === false
      ) {
        const tempItem = this.items.filter((e) => e.name === 'WATCH_REPORTS')

        this.$emit('uChck', item)

        if (
          this.selected.find((e) => e.name === 'WATCH_REPORTS') !== undefined &&
          this.selected
            .map((e) => e.name)
            .filter(
              (e) => e !== 'WATCH_REPORTS' && e !== 'UPDATEATTENDANCE_REPORTS'
            ).length === 0
        ) {
          this.$emit('uChck', tempItem[0])
        }
        this.selected = []

        return
      }

      if (value) {
        this.$emit('chck', item)
      } else {
        this.$emit('uChck', item)
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
  },
}
</script>

<style scoped>
/deep/ .v-datatable.v-table > thead {
  display: table-row-group;
}
/deep/ .v-datatable.v-table > tbody {
  max-height: 40vh;
  min-height: 40vh;
  overflow-y: auto;
  overflow-x: auto;
  display: table-row-group;
}
</style>
